import { Navigate, NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, Users, Newspaper, ShieldUser, LogOut, Loader2, ExternalLink, KeyRound, Settings, Scale, GraduationCap, Megaphone } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/site/Logo";

const items = [
  { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard, id: "admin-nav-dashboard", end: true },
  { to: "/admin/ap", label: "Assistants (AP)", icon: Users, id: "admin-nav-aps" },
  { to: "/admin/communiques", label: "Communiqués", icon: Newspaper, id: "admin-nav-articles" },
  { to: "/admin/administrateurs", label: "Administrateurs", icon: ShieldUser, id: "admin-nav-users", superOnly: true },
  { to: "/admin/essap", label: "ESSAP · Présentation", icon: GraduationCap, id: "admin-nav-essap", end: true },
  { to: "/admin/essap/publications", label: "ESSAP · Publications", icon: Megaphone, id: "admin-nav-essap-posts" },
  { to: "/admin/mention-legale", label: "Mention légale", icon: Scale, id: "admin-nav-legal" },
  { to: "/admin/parametres", label: "Logo du site", icon: Settings, id: "admin-nav-settings" },
  { to: "/admin/compte", label: "Mon compte", icon: KeyRound, id: "admin-nav-account" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center"><Loader2 className="h-8 w-8 animate-spin text-emerald-700" /></div>;
  if (!user) return <Navigate to="/connexion" replace />;
  const nav = items.filter((i) => !i.superOnly || user.role === "super_admin");

  return (
    <div className="min-h-screen bg-slate-50 lg:grid lg:grid-cols-[260px_1fr]">
      <aside className="bg-white border-b lg:border-b-0 lg:border-r border-emerald-900/10 lg:sticky lg:top-0 lg:h-screen flex flex-col">
        <div className="p-5"><Logo /></div>
        <nav className="flex lg:flex-col gap-1 px-3 overflow-x-auto pb-3 lg:pb-0">
          {nav.map((i) => (
            <NavLink key={i.to} to={i.to} end={i.end} data-testid={i.id}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm whitespace-nowrap transition-colors ${isActive ? "bg-emerald-700 text-white font-semibold" : "text-slate-600 hover:bg-emerald-50 hover:text-emerald-800"}`}>
              <i.icon className="h-4 w-4" /> {i.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:block mt-auto p-4 border-t border-emerald-900/10 space-y-3">
          <NavLink to="/" className="flex items-center gap-2 text-sm text-slate-500 hover:text-emerald-800"><ExternalLink className="h-4 w-4" /> Voir le site public</NavLink>
          <div className="text-sm">
            <div data-testid="admin-user-name" className="font-semibold text-slate-900 truncate">{user.name}</div>
            <div className="text-xs text-slate-500 truncate">{user.email}</div>
          </div>
          <button onClick={logout} data-testid="admin-logout-button" className="flex items-center gap-2 text-sm text-rose-600 hover:text-rose-700"><LogOut className="h-4 w-4" /> Déconnexion</button>
        </div>
        <button onClick={logout} data-testid="admin-logout-button-mobile" className="lg:hidden mx-5 mb-3 flex items-center gap-2 text-sm text-rose-600"><LogOut className="h-4 w-4" /> Déconnexion</button>
      </aside>
      <main className="p-4 sm:p-8 min-w-0"><Outlet /></main>
    </div>
  );
}
